var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "col-lg-12" }, [
      _c("div", { staticClass: "panel panel-default" }, [
        _c("div", { staticClass: "panel-heading" }, [
          _c("div", { staticClass: "row " }, [
            _c("div", { staticClass: "col-6 align-self-center" }, [
              _c("h2", [_vm._v(_vm._s(_vm.__("report.reported_content")))]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "panel-body mt-1" }, [
          _c("div", { staticClass: "w-100 border-bottom-primary mb-1" }, [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("h4", { staticClass: "mt-1" }, [
                _vm._v(_vm._s(_vm.__("report.all_reports"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "panel-body mt-1 card p-2" }, [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("label", [_vm._v(_vm._s(_vm.__("table.show_amount")))]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.reports_amount,
                        expression: "reports_amount",
                      },
                    ],
                    staticClass: "form-control ml-05",
                    attrs: { id: "report_amount" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.reports_amount = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "15" } }, [_vm._v("15")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "20" } }, [_vm._v("20")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "25" } }, [_vm._v("25")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "50" } }, [_vm._v("50")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "100" } }, [_vm._v("100")]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex align-items-center ml-auto" }, [
                _c("label", [_vm._v(_vm._s(_vm.__("table.keyword")) + ": ")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search_text,
                      expression: "search_text",
                    },
                  ],
                  staticClass: "form-control ml-05",
                  attrs: { type: "text" },
                  domProps: { value: _vm.search_text },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search_text = $event.target.value
                      },
                      _vm.debounceInput,
                    ],
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-primary ml-05",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.getReports()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.__("globals.search")))]
              ),
            ]),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "table table-bordered table-striped mt-1" },
              [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        staticStyle: { width: "10%" },
                        attrs: { scope: "col" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.changeActiveField("id")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("p", [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(_vm.__("table.id")) +
                                "\n                                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "ml-auto" }, [
                            _c("i", {
                              class:
                                "feather icon-arrow-up " +
                                (this.sort_field === "id" &&
                                this.sort_order === "asc"
                                  ? "text-dark"
                                  : "text-light"),
                              staticStyle: { "margin-right": "-6px" },
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class:
                                "feather icon-arrow-down " +
                                (this.sort_field === "id" &&
                                this.sort_order === "desc"
                                  ? "text-dark"
                                  : "text-light"),
                            }),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { width: "20%" },
                        attrs: { scope: "col" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.changeActiveField("full_name")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("p", [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(_vm.__("report.reported_by")) +
                                "\n                                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "ml-auto" }, [
                            _c("i", {
                              class:
                                "feather icon-arrow-up " +
                                (this.sort_field === "full_name" &&
                                this.sort_order === "asc"
                                  ? "text-dark"
                                  : "text-light"),
                              staticStyle: { "margin-right": "-6px" },
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class:
                                "feather icon-arrow-down " +
                                (this.sort_field === "full_name" &&
                                this.sort_order === "desc"
                                  ? "text-dark"
                                  : "text-light"),
                            }),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { width: "30%" },
                        attrs: { scope: "col" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.changeActiveField("comment")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("p", [
                            _vm._v(
                              "\n                                          " +
                                _vm._s(_vm.__("table.comment")) +
                                "\n                                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "ml-auto" }, [
                            _c("i", {
                              class:
                                "feather icon-arrow-up " +
                                (this.sort_field === "comment" &&
                                this.sort_order === "asc"
                                  ? "text-dark"
                                  : "text-light"),
                              staticStyle: { "margin-right": "-6px" },
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class:
                                "feather icon-arrow-down " +
                                (this.sort_field === "comment" &&
                                this.sort_order === "desc"
                                  ? "text-dark"
                                  : "text-light"),
                            }),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { width: "14%" },
                        attrs: { scope: "col" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.changeActiveField("reportable_type")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("p", [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(_vm.__("report.reported_type")) +
                                "\n                                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "ml-auto" }, [
                            _c("i", {
                              class:
                                "feather icon-arrow-up " +
                                (this.sort_field === "reportable_type" &&
                                this.sort_order === "asc"
                                  ? "text-dark"
                                  : "text-light"),
                              staticStyle: { "margin-right": "-6px" },
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class:
                                "feather icon-arrow-down " +
                                (this.sort_field === "reportable_type" &&
                                this.sort_order === "desc"
                                  ? "text-dark"
                                  : "text-light"),
                            }),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticStyle: { width: "14%" },
                        attrs: { scope: "col" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.changeActiveField("updated_at")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("p", [
                            _vm._v(
                              "\n                                            " +
                                _vm._s(_vm.__("report.reported_date")) +
                                "\n                                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "ml-auto" }, [
                            _c("i", {
                              class:
                                "feather icon-arrow-up " +
                                (this.sort_field === "updated_at" &&
                                this.sort_order === "asc"
                                  ? "text-dark"
                                  : "text-light"),
                              staticStyle: { "margin-right": "-6px" },
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class:
                                "feather icon-arrow-down " +
                                (this.sort_field === "updated_at" &&
                                this.sort_order === "desc"
                                  ? "text-dark"
                                  : "text-light"),
                            }),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("th", {
                      staticStyle: { width: "12%" },
                      attrs: { scope: "col" },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm.loading
                      ? _c("tr", { staticClass: "text-center" }, [_vm._m(1)])
                      : [
                          _vm._l(_vm.reports, function (report, index) {
                            return _c("tr", { key: index }, [
                              _c("td", [_vm._v(_vm._s(report.id))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(report.full_name))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(report.comment))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.typeFormat(report.reportable_type))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.timeFormat(report.updated_at))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-primary",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.viewDetailsModal(report.id)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(_vm.__("table.view")) +
                                        "\n                                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-danger",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.deleteReport(
                                          report.id,
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(_vm.__("table.delete")) +
                                        "\n                                        "
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          }),
                          _vm._v(" "),
                          _vm.reports.length === 0
                            ? _c("tr", { staticClass: "text-center" }, [
                                _c("td", { attrs: { colspan: "6" } }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.__("report.no_reports_yet")) +
                                      "\n                                    "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("div", [
                !_vm.loading && _vm.reports.length > 0
                  ? _c("p", [
                      this.total_reports === 1
                        ? _c("span", [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.__("table.showing")) +
                                " 1 " +
                                _vm._s(_vm.__("globals.report")) +
                                "\n                                "
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.__("table.showing")) +
                                " " +
                                _vm._s(
                                  this.current_page === 1
                                    ? this.current_page
                                    : 1 +
                                        this.reports_amount *
                                          (this.current_page - 1)
                                ) +
                                " " +
                                _vm._s(_vm.__("globals.to")) +
                                " " +
                                _vm._s(this.showing_reports) +
                                " " +
                                _vm._s(_vm.__("globals.of")) +
                                " " +
                                _vm._s(this.total_reports) +
                                " " +
                                _vm._s(_vm.__("globals.reports")) +
                                "\n                                "
                            ),
                          ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ml-auto" }, [
                _c(
                  "ul",
                  { staticClass: "pagination" },
                  [
                    _c("li", { staticClass: "page-item previous" }, [
                      _c(
                        "a",
                        {
                          staticClass: "page-link",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.goPreviousPage()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.__("table.previous")))]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.total_pages, function (page) {
                      return _c(
                        "li",
                        {
                          class:
                            "page-item " +
                            (_vm.current_page === page ? "active" : ""),
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "page-link",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.changePage(page)
                                },
                              },
                            },
                            [_vm._v(_vm._s(page))]
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("li", { staticClass: "page-item next" }, [
                      _c(
                        "a",
                        {
                          staticClass: "page-link",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.goNextPage()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.__("table.next")))]
                      ),
                    ]),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.view_details
      ? _c(
          "div",
          [
            _c("report-modal", {
              attrs: { report_id: this.report_id },
              on: { closeModal: _vm.closeDetailsModal },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "avatar bg-rgba-primary float-left" }, [
      _c("div", { staticClass: "avatar-content" }, [
        _c("i", {
          staticClass: "feather icon-alert-triangle text-primary font-medium-3",
        }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "6" } }, [
      _c("span", {
        staticClass: "spinner-border spinner-border-md text-primary",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }